/** Eikos policy emission API (emit_policy) — request/response types */

export interface EikosEmitTelefono {
  COD_PAIS: string;
  NUMERO: string;
}

export interface EikosEmitDomicilio {
  CALLE: string;
  NO_EXTERIOR: string;
  NO_INTERIOR: string;
  COLONIA: string;
  COD_POSTAL: string;
  PAIS: number;
}

export interface EikosEmitContacto {
  TEL_PARTICULAR: EikosEmitTelefono;
  TEL_MOVIL: EikosEmitTelefono;
  EMAIL: string;
}

export interface EikosEmitPersonaFisica {
  PRIMER_NOMBRE: string;
  SEGUNDO_NOMBRE: string;
  APELLIDO_PATERNO: string;
  APELLIDO_MATERNO: string;
  GENERO: string;
  EDO_CIVIL: string;
  CURP: string;
  OCUPACION: string;
}

export interface EikosEmitPersonaMoral {
  RAZON_SOCIAL: string;
  ID_REG_CAPITAL: string;
}

export interface EikosEmitContratante {
  PERSONALIDAD: "PF" | "PM";
  RFC?: string;
  ORIGEN?: { FECHA_NACIMIENTO: string; PAIS_NACIMIENTO: string };
  DOMICILIO?: EikosEmitDomicilio;
  CONTACTO?: EikosEmitContacto;
  PERSONA_FISICA?: EikosEmitPersonaFisica;
  PERSONA_MORAL?: EikosEmitPersonaMoral;
}

export interface EikosEmitVehiculo {
  CLAVE: string;
  MODELO: string;
  NO_SERIE: string;
  NO_MOTOR: string;
  PLACAS: string;
}

export interface EikosEmitFacturacion {
  RFC: string;
  RAZON_SOCIAL: string;
  COD_POSTAL: string;
  ID_REG_FISCAL: number;
  ID_USO_CFDI: string;
  EMAIL: string;
}

export interface EikosEmitPolicyRequest {
  ID_COTIZACION: number;
  VIGENCIA_INI: string;
  VIGENCIA_FIN: string;
  ID_EMPLEADO?: string;
  NUMERO_AGENCIA?: string;
  MENSUALIDAD: number;
  ID_CREDITO: string;
  CONTRATANTE: EikosEmitContratante;
  VEHICULO: EikosEmitVehiculo;
  FACTURACION?: EikosEmitFacturacion;
}

export interface EikosEmitPolicyResponse {
  ID_COTIZACION: number;
  POLIZA: string;
  POLIZA_URL: string;
  VIGENCIA_INI: string;
  VIGENCIA_FIN: string;
}
